<template>
  <div class="mb-3">
    <b-card no-body>
      <b-card-header>
        <h2>{{ data.optionData.name }}: {{ isRecommendedText }} </h2>
      </b-card-header>
      <b-card-body>
        <div v-if="warnings.length>0">
          <h3>Considerations</h3>
          <p>Based on your inputs, RxPave recommends reviewing the following observations relevant to this specific treatment:</p>
          <b-list-group class="mb-3">
            <b-list-group-item v-for="warning in warnings" variant="warning">
              <strong>{{ warning.title }}:</strong> {{ warning.message }}<br>
            </b-list-group-item>
          </b-list-group>
          <hr size="10">
        </div>

        <h3>Pavement Condition Rating</h3>
        <b-row>
          <b-col md="6" align="center" variant="success">
            <b-alert show :variant="pcrCheckAlertVariant">
              <b-row align-v="center">
                <b-col md="3">
                  <!--Show check if pcr is OK, 'X' if not ok -->
                  <font-awesome-icon
                    v-if="data.pcrIsOk"
                    :icon="['far','check-circle']"
                    size="5x"
                  />
                  <font-awesome-icon
                    v-if="!data.pcrIsOk"
                    :icon="['far','times-circle']"
                    size="5x"
                  />
                </b-col>
                <b-col>
                  {{ pcrCheckText }}
                </b-col>
              </b-row>
            </b-alert>
          </b-col>
          <b-col>
            <PCRCheckChartPlotly
              :renewal-type-name="data.optionData.name"
              :renewal-type-id="data.renewalOption"
              :pcr-value="data.pcrScore"
              :pcr-is-ok="data.pcrIsOk"
              :max-pcr-allowed="data.optionData.maxPCR"
              :min-pcr-allowed="data.optionData.minPCR"
            />
          </b-col>
        </b-row>

        <hr>

        <h3>Distress Survey Results</h3>
        <!--{{data.distressScores}}-->

        <DistressScoreReport
          :renewal-option="data.renewalOption"
          :option-data="data.optionData"
          :renewal-rankings="rankings"
          :score-allows-recommendation="data.scoreAllowsRecommendation"
          :distress-viable="data.distressViable"
          :distress-scores="data.distressScores"
        />
      </b-card-body>
    </b-card>
  </div>
</template>

<script>

  // import PCRCheckChartChartJs from './PCRCheckChartChartJS'
  import PCRCheckChartPlotly from './PCRCheckChartPlotly'
  import DistressScoreReport from './DistressScoreReport'

  export default {
    name: "RenewalOptionDetails",
    components: {
      PCRCheckChartPlotly,
      DistressScoreReport
    },
    props: {
      data: {
        type: Object,
        required: true
      },
      rankings: {
        type: Array,
        required: true
      },
      warnings: {
        type: Array,
        required: true
      }
    },
    computed: {
      pcrCheckText() {
        return this.data.pcrIsOk ?
          (
            "Passed - The PCR value of " + this.data.pcrScore + " is within the recommended range of "
            + this.data.optionData.minPCR + " to " + this.data.optionData.maxPCR + " points for "
            + this.data.optionData.name + "."
          ) : (
            "Failed - The PCR value of " + this.data.pcrScore + " is outside the recommended range of "
            + this.data.optionData.minPCR + " to " + this.data.optionData.maxPCR + " points for "
            + this.data.optionData.name + "."
          )
      },
      pcrCheckAlertVariant() {
        return this.data.pcrIsOk ? "success" : "danger"
      },
      isRecommendedText (){
        return this.data.isViable ? "Viable" : "Not Recommended"
      },
    },
    mounted() {
      console.log(this.data)
    }
  }
</script>

<style scoped>
  /*h1 {*/
    /*margin-bottom: 0;*/
  /*}*/
  /*.pcr-chart-container {*/
    /*height: 10rem;*/
  /*}*/

</style>